import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Chip,
    TablePagination,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import { useState } from "react";
import { motion } from "motion/react";
import { Flip, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toast_config } from "../toastify/config";
import LoadingSpinner from "../Spinner";
import apiRc from "../../axios/axios";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import { jwtDecode } from "jwt-decode";

const MotionTableContainer = motion(TableContainer);
const MotionTableRow = motion(TableRow);

const TablaAhorrador = ({ contratos }) => {
    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [isLoading, setIsLoading] = useState(false);

    if (!contratos.length) {
        return (
            <Paper sx={{ p: 6, textAlign: "center" }}>
                No existen contratos de ahorro.
            </Paper>
        );
    }

    const obtenerTipoAbono = (tipo) => {
        switch (tipo) {
            case 1:
                return "SEMANAL";

            case 2:
                return "QUINCENAL";

            case 3:
                return "MENSUAL";

            default:
                return "DESCONOCIDO";
        }
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 5));
        setPage(0);
    };

    const revisarSeguimientoAbono = (e, ic) => {


        const infoAbonos = async () => {
            try {
                setIsLoading(true)

                const token = sessionStorage.getItem("token");

                const { data } = await apiRc.get(`/ahorrador/info-seguimiento-abonos/${btoa(ic)}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })

                navigate(`/seguimiento-ahorro`, {
                    state: {
                        abonos: data.abonos,
                        rendimiento: data.rendimiento_anual,
                    },
                })

            } catch (error) {
                let msg_error = "";

                if (error.response) {
                    if (error.response.data?.mensaje) {
                        msg_error = error.response.data.mensaje;
                    } else {
                        msg_error = "Ocurrió un error al obtener información de seguimiento de abonos, favor de volver a intentarlo.";
                    }

                } else {
                    msg_error = "No hay respuesta por parte del servidor.";
                }
                setIsLoading(false)
                toast.error(msg_error, toast_config);
            }
        }



        infoAbonos()

    }

    const verContrato = (e, ic) => {

        const obtenerContrato = async () => {

            setIsLoading(true)

            try {
                const token = sessionStorage.getItem("token");

                const { data } = await apiRc(`/obtener-contrato-pdf/${btoa(ic)}`, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': `Bearer ${token}`
                    },
                })

                const byteCharacters = atob(data.b64html);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: 'application/pdf'
                });

                const url = URL.createObjectURL(blob);
                setIsLoading(false)
                window.open(url, '_blank');
            } catch (error) {
                let msg_error = "";

                if (error.response) {
                    if (error.response.data?.mensaje) {
                        msg_error = error.response.data.mensaje;
                    } else {
                        msg_error = "Ocurrió un error al obtener información de contrato, favor de volver a intentarlo.";
                    }

                } else {
                    msg_error = "No hay respuesta por parte del servidor.";
                }

                setIsLoading(false)

                toast.error(msg_error, toast_config);
            }
        }





        obtenerContrato()

    }

    const firmarContrato = (e, ic) => {
        const token = sessionStorage.getItem("token");

        const decoded = jwtDecode(token)
        const celular = String(decoded?.celular)
        
        navigate(`/firmar-contrato`, {
            state: {
                folioContrato: String(ic).padStart(5, 0),
                ultimos4Cel: celular.substring(celular.length - 4, celular.length),
            },
        })
    }

    return (
        <MotionTableContainer>
            {isLoading && <LoadingSpinner />}
            <Table>

                <TableHead>

                    <TableRow>

                        <TableCell>Folio</TableCell>

                        <TableCell>Cantidad</TableCell>

                        <TableCell>Tipo Abono</TableCell>

                        <TableCell>Tipo Contrato</TableCell>

                        <TableCell>Seguimiento</TableCell>

                        <TableCell>Contrato</TableCell>

                        <TableCell>Firmar</TableCell>

                    </TableRow>

                </TableHead>

                <TableBody>

                    {contratos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((contrato, index) => (

                        <MotionTableRow key={contrato.id_contrato} initial={{ opacity: 0, y: 15, }} animate={{ opacity: 1, y: 0, }} transition={{ duration: 0.3, delay: index * 0.07, ease: "easeOut", }} >

                            <TableCell>#{String(contrato.id_contrato).padStart(5, '0')}</TableCell>

                            <TableCell>
                                ${contrato.cantidad}
                            </TableCell>

                            <TableCell>
                                {obtenerTipoAbono(contrato.id_tipo_abono)}
                            </TableCell>

                            <TableCell>
                                {contrato.id_tipo_contrato === 1 ? "ANUAL" : contrato.tipo_contrato === 2 ? "BIANUAL" : 'DESCONOCIDO'}
                            </TableCell>

                            <TableCell>

                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<VisibilityOutlinedIcon />}
                                    onClick={(e) => revisarSeguimientoAbono(e, contrato.id_contrato)}
                                    sx={{
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        borderColor: "#517950",
                                        color: "#517950",
                                        px: 2,
                                        "&:hover": {
                                            borderColor: "#3f633e",
                                            backgroundColor: "rgba(81,121,80,.07)",
                                        },
                                    }}
                                >
                                    Ver abonos
                                </Button>

                            </TableCell>

                            <TableCell>

                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<PictureAsPdfOutlinedIcon />}
                                    onClick={(e) => verContrato(e, contrato.id_contrato)}
                                    sx={{
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        borderColor: "#b85c5c",
                                        color: "#b85c5c",
                                        px: 2,
                                        "&:hover": {
                                            borderColor: "#963f3f",
                                            backgroundColor: "rgba(184,92,92,.07)",
                                        },
                                    }}
                                >
                                    Ver contrato
                                </Button>

                            </TableCell>

                            <TableCell>

                                {!contrato.id_firma ? (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        startIcon={<DrawOutlinedIcon />}
                                        onClick={(e) => firmarContrato(e, contrato.id_contrato)}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: 700,
                                            px: 2,
                                            background:
                                                "linear-gradient(135deg, #2EB872, #1B7F52)",
                                            boxShadow: "none",
                                            "&:hover": {
                                                background:
                                                    "linear-gradient(135deg, #36C97D, #208E5B)",
                                                boxShadow: "0 4px 12px rgba(27,127,82,.20)",
                                            },
                                        }}
                                    >
                                        Firmar
                                    </Button>
                                ) : (
                                    <Chip
                                        icon={<CheckCircleOutline fontSize="small" />}
                                        label="Firmado"
                                        size="small"
                                        sx={{
                                            borderRadius: "999px",
                                            fontWeight: 700,
                                            fontSize: "0.75rem",
                                            backgroundColor: "rgba(46, 184, 114, 0.12)",
                                            color: "#16734A",
                                            border: "1px solid rgba(46, 184, 114, 0.25)",
                                            px: 0.5,
                                            "& .MuiChip-icon": {
                                                color: "#1B9A63",
                                                fontSize: "17px",
                                            },
                                        }}
                                    />
                                )}

                            </TableCell>

                        </MotionTableRow>

                    ))}

                </TableBody>

            </Table>
            <TablePagination
                component="div"
                count={contratos.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Registros por página"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

        </MotionTableContainer>
    );
};

export default TablaAhorrador;